export const toggleColumns = [
  { id: 1, name: "Invoice#" },
  { id: 2, name: "Amount" },
  { id: 7, name: "Date" },
  { id: 5, name: "Type" },
  { id: 6, name: "Source" },
  { id: 8, name: "File#" },
  { id: 9, name: "Name" },
  { id: 9, name: "Last Name" },
  { id: 9, name: "Description" },
  { id: 10, name: "Created By" },
  { id: 10, name: "Updated By" },
];

export const searchInvoicePills = [
  { id: 1, title: "Amount", value: "Rs 305,284,064", variant: "dark" },
  { id: 1, title: "Invoices Found", value: "7,301", variant: "info" },
];

export const searchInvoiceTableColumns = [
  { id: 1, name: "Data 1" },
  { id: 2, name: "Data 2" },
  { id: 3, name: "Data 3" },
  { id: 4, name: "Data 4" },
  { id: 5, name: "Data 5" },
];

export const searchInvoiceTableRows = [
  {
    id: 1,
    col1: "Data 1",
    col2: "Data 2",
    col3: "Data 3",
    col4: "Data 4",
    col5: "Data 5",
  },
  {
    id: 2,
    col1: "Data 6",
    col2: "Data 7",
    col3: "Data 8",
    col4: "Data 9",
    col5: "Data 10",
  },
  {
    id: 3,
    col1: "Data 11",
    col2: "Data 12",
    col3: "Data 13",
    col4: "Data 14",
    col5: "Data 15",
  },
  {
    id: 4,
    col1: "Data 16",
    col2: "Data 17",
    col3: "Data 18",
    col4: "Data 19",
    col5: "Data 20",
  },
];
